import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Base } from '../common/base';
import { ComisionesService } from '../../services/comisiones/comisiones.service';
import { HttpResponse } from '@angular/common/http';
import { AuthService } from '../../services/security/auth.service';
import { TrackData } from '../../models/app-track/track-data.model';
import { TrackingService } from '../../services/app-track/tracking.service';

@Component({
  selector: 'app-comisiones',
  templateUrl: './comisiones.component.html',
  styleUrls: ['./comisiones.component.css'],
})
export class ComisionesComponent extends Base implements AfterViewInit, OnInit {
  data: any = {};
  tipoUsuario: 'INTERNO' | 'EXTERNO' = 'INTERNO';

  documentoUsuario: string = '';
  codigoUsuario: string = '';
  identificacionParaDescarga: string = '';
  nombreAsesor: string = '';

  frmComisiones: FormGroup;
  generalMessage: string = '';
  haveDate: boolean = false;
  haveResponde: boolean = false;
  listaAnios: number[] = [];
  listaPeriod: string[] = [];
  comprobantesOva: any[] = [];
  detalladoOva: any[] = [];
  logInfo: any;
  cedulaAsesor: any;
  trackDataCarnet!: TrackData;

  constructor(
    private authService: AuthService,
    private comisionesService: ComisionesService,
    private mainCmp: MaincontainerComponent,
    private fb: FormBuilder
  ) {
    super();
    this.frmComisiones = this.fb.group({
      documentAño: ['', Validators.required],
      documentPeriodo: ['', Validators.required],
    });
  }

  get anioSeleccionado(): boolean {
    return !!this.frmComisiones.get('documentAño')?.value;
  }

  get getControl(): { [key: string]: any } {
    return this.frmComisiones.controls;
  }

  async ngOnInit(): Promise<void> {
    try {
      this.logInfo = await this.authService.getAuthInfo();

      this.nombreAsesor =
        `${this.logInfo?.nombre ?? ''} ${this.logInfo?.primerApellido ?? ''} ${
          this.logInfo?.segundoApellido ?? ''
        }`.trim() || 'Asesor';


      const rolCompleto = this.logInfo.roles[0].nombreRol;
      const tipoRol = this.extraerTipoRol(rolCompleto);
      this.tipoUsuario =
        tipoRol.toUpperCase() === 'EXTERNO' ? 'EXTERNO' : 'INTERNO';

      this.documentoUsuario = this.limpiarDocumento(this.logInfo.document);


      if (this.tipoUsuario === 'INTERNO') {
        this.codigoUsuario =
          this.logInfo.codAsesor && this.logInfo.codAsesor.trim() !== ''
            ? this.logInfo.codAsesor
            : this.documentoUsuario;

        this.identificacionParaDescarga = this.codigoUsuario;

        if (this.logInfo.codAsesor && this.logInfo.codAsesor.trim() === '') {
          console.log(
            'ℹ️ Usuario INTERNO sin codAsesor. Usando documento para consulta.'
          );
        }
      } else {
        this.codigoUsuario =
          this.logInfo.codAsesor && this.logInfo.codAsesor.trim() !== ''
            ? this.logInfo.codAsesor
            : this.documentoUsuario;

        this.identificacionParaDescarga = this.codigoUsuario;
      }

      if (!this.documentoUsuario) {
        this.generalMessage =
          'No se pudo obtener la identificación del usuario.';
        return;
      }

      const anioActual = new Date().getFullYear();
      this.listaAnios = [anioActual - 1, anioActual];

      this.frmComisiones.get('documentPeriodo')?.disable();

      this.frmComisiones.valueChanges.subscribe(() => {
        if (this.frmComisiones.valid) this.generalMessage = '';
      });

      this.frmComisiones
        .get('documentAño')
        ?.valueChanges.subscribe((anioSeleccionado) => {
          if (anioSeleccionado) this.updatePeriodos(anioSeleccionado);
        });

      this.obtenerPeriodos();
    } catch (error) {
      this.generalMessage =
        'Ocurrió un error al cargar la información del usuario.';
    }

    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    this.nombreAsesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';

    this.trackDataCarnet = {
      module: 'Mis comisiones',
      category: 'N/A',
      submodule: 'Consulta Comisiones',
      functionality: 'Generar comprobante comisiones',
      cedulaAsesor: this.cedulaAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombreAsesor,
      identificadorInteraccion: 'AFL_CONSULTA_AFL_GENERAR_COMPROBANTE_AFL'
    };
  }

  private extraerTipoRol(nombreRol: string): string {
    const palabras = nombreRol.trim().split(/\s+/);
    return palabras[palabras.length - 1];
  }

  private limpiarDocumento(documento: string): string {
    return documento ? documento.replace(/\D/g, '') : '';
  }

  private formatearPeriodo(periodo: string): string {
    if (!periodo) return '';

    const fechaMatch = periodo.match(/^(\d{4})(\d{2})(\d{2})$/);
    if (fechaMatch) {
      const anio = fechaMatch[1];
      const mes = fechaMatch[2];
      const dia = fechaMatch[3];
      return `${anio}/${mes}/${dia}`;
    }

    return periodo;
  }

  updatePeriodos(añoSeleccionado: number): void {
    this.listaPeriod = [];
    this.frmComisiones.get('documentPeriodo')?.setValue('');

    if (!añoSeleccionado || !this.tipoUsuario) {
      this.frmComisiones.get('documentPeriodo')?.disable();
      return;
    }

    this.frmComisiones.get('documentPeriodo')?.enable();

    this.comisionesService
      .obtenerPeriodosValidos(añoSeleccionado, this.tipoUsuario)
      .subscribe({
        next: (res) => {
          this.listaPeriod = res || [];
          if (this.listaPeriod.length === 0) {
            this.frmComisiones.get('documentPeriodo')?.disable();
          } else {
            this.frmComisiones.get('documentPeriodo')?.enable();
          }
        },
        error: () => {
          this.listaPeriod = [];
          this.frmComisiones.get('documentPeriodo')?.disable();
        },
      });
  }

  ComisionValidator(): boolean {
    const año = this.frmComisiones.get('documentAño')?.value;
    const periodo = this.frmComisiones.get('documentPeriodo')?.value;

    if (!año || !periodo) {
      this.generalMessage = 'FALTAN CAMPOS POR DILIGENCIAR.';
      this.haveResponde = false;
      this.haveDate = false;
      return false;
    }

    this.generalMessage = '';
    return true;
  }

  generarDetalleComisiones() {
    if (!this.identificacionParaDescarga) {
      this.generalMessage =
        'No es posible generar el detalle. Falta identificador para la consulta.';
      return;
    }
    if (!this.ComisionValidator()) return;


    const anio = this.frmComisiones.get('documentAño')?.value;
    const periodo = this.frmComisiones.get('documentPeriodo')?.value;
    const periodoFormateado = this.formatearPeriodo(periodo);

    const quincena =
      this.tipoUsuario === 'EXTERNO' ? periodo.substring(0, 2) : undefined;

    this.comisionesService
      .descargarComprobanteGeneral(
        anio,
        periodo,
        this.codigoUsuario,
        this.tipoUsuario,
        quincena,
        this.nombreAsesor,
        this.documentoUsuario
      )
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          const contentDisposition = response.headers.get(
            'Content-Disposition'
          );
          const match = /filename="(.+)"/.exec(contentDisposition || '');
          const filename =
            match?.[1] ||
            `Detalle_${periodoFormateado}_${anio}_${this.identificacionParaDescarga}.xlsx`;

          const url = window.URL.createObjectURL(response.body!);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(url);

          this.generalMessage = '';
        },
        error: () => {
          this.generalMessage =
            'NO EXISTE DETALLE PARA EL PERIODO SELECCIONADO.';
          console.warn('❌ No hay datos disponibles');
        },
      });
  }

  generarComprobanteComisiones() {
    if (!this.identificacionParaDescarga) {
      this.generalMessage =
        'No es posible generar el comprobante. Falta identificador para la consulta.';
      return;
    }
    if (!this.ComisionValidator()) return;


    const anio = this.frmComisiones.get('documentAño')?.value;
    const periodo = this.frmComisiones.get('documentPeriodo')?.value;
    const periodoFormateado = this.formatearPeriodo(periodo);

    if (this.tipoUsuario === 'EXTERNO') {
      this.comisionesService
        .descargarZipExterno(
          anio,
          periodo,
          this.identificacionParaDescarga,
          this.tipoUsuario,
          this.nombreAsesor,
          this.documentoUsuario
        )
        .subscribe({
          next: (response: HttpResponse<Blob>) => {
            const contentDisposition = response.headers.get(
              'Content-Disposition'
            );
            const match = /filename="(.+)"/.exec(contentDisposition || '');
            const filename =
              match?.[1] ||
              `Archivos_Comisiones_${periodoFormateado}_${anio}_${this.documentoUsuario}.zip`;

            const url = window.URL.createObjectURL(response.body!);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(url);

            this.generalMessage = '';
          },
          error: (err) => {
            this.generalMessage =
              'NO EXISTEN ARCHIVOS PARA EL PERIODO SELECCIONADO.';
            console.warn('❌ No hay datos disponibles:', err);
          },
        });
    } else {
      const quincena = undefined;
      this.comisionesService
        .descargarComprobanteGeneral(
          anio,
          periodo,
          this.documentoUsuario,
          this.tipoUsuario,
          quincena,
          this.nombreAsesor,
          this.documentoUsuario
        )
        .subscribe({
          next: (response: HttpResponse<Blob>) => {
            const contentDisposition = response.headers.get(
              'Content-Disposition'
            );
            const match = /filename="(.+)"/.exec(contentDisposition || '');
            const filename =
              match?.[1] ||
              `Detalle_${periodoFormateado}_${anio}_${this.identificacionParaDescarga}.xlsx`;

            const url = window.URL.createObjectURL(response.body!);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();
            window.URL.revokeObjectURL(url);

            this.generalMessage = '';
          },
          error: (err) => {
            this.generalMessage =
              'NO EXISTE COMPROBANTE PARA EL PERIODO SELECCIONADO.';
            console.warn('❌ No hay datos disponibles:', err);
          },
        });
    }
  }

  obtenerDocumentoSesion(): string {
    return this.identificacionParaDescarga;
  }

  configurarVistaSegunUsuario(): void {
    console.log(`Cargando vista para asesor ${this.tipoUsuario}`);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle('CONSULTA MIS COMISIONES');
    }, 100);
  }

  obtenerPeriodos(): void {
    const anioSeleccionado = this.frmComisiones.get('documentAño')?.value;
    if (anioSeleccionado && this.tipoUsuario) {
      this.updatePeriodos(anioSeleccionado);
    }
  }

  consultarComprobantesDesdeOVA() {
    if (!this.identificacionParaDescarga) {
      this.generalMessage =
        'No es posible consultar comprobantes. Falta identificador para la consulta.';
      return;
    }
    if (!this.ComisionValidator()) return;

    const jsonParametros = JSON.stringify({
      anio: this.frmComisiones.get('documentAño')?.value,
      periodo: this.frmComisiones.get('documentPeriodo')?.value,
      documento: this.identificacionParaDescarga,
      tipoUsuario: this.tipoUsuario,
    });

    const dto = { jsonParametros };

    this.comisionesService.consultarComprobantes(dto).subscribe({
      next: (res) => {
        this.comprobantesOva = res.data || [];
      },
      error: (err) => {
        console.error('❌ Error consultando comprobantes OVA:', err);
      },
    });
  }

  consultarDetalladoDesdeOVA() {
    if (!this.identificacionParaDescarga) {
      this.generalMessage =
        'No es posible consultar el detallado. Falta identificador para la consulta.';
      return;
    }
    if (!this.ComisionValidator()) return;

    const jsonParametros = JSON.stringify({
      anio: this.frmComisiones.get('documentAño')?.value,
      periodo: this.frmComisiones.get('documentPeriodo')?.value,
      documento: this.identificacionParaDescarga,
      tipoUsuario: this.tipoUsuario,
    });

    const dto = { jsonParametros };

    this.comisionesService.consultarDetallado(dto).subscribe({
      next: (res) => {
        this.detalladoOva = res.data || [];
      },
      error: (err) => {
        console.error('❌ Error consultando detallado OVA:', err);
      },
    });
  }

  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  private getCurrentTimestamp(): string {
  const fecha = new Date();
  const yyyy = fecha.getFullYear();
  const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const dd = fecha.getDate().toString().padStart(2, '0');
  const HH = fecha.getHours().toString().padStart(2, '0');
  const mm = fecha.getMinutes().toString().padStart(2, '0');
  const ss = fecha.getSeconds().toString().padStart(2, '0');
  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
}
